export class ScheduleGenerateFilter {
  classId: number;
  sectionId: number;
  linkScheduleCategoryId: number;
  scheduleGenerateType?: number;
}
export class ScheduleGenerate {
  classId: number;
  sectionId: number;
  linkScheduleCategoryId: number;
  schoolPeriod: SchoolPeriods[];
}
export class SchoolPeriods {
  schedulePeriodId: number;
  sectionSubjectId?: number;
  teacherId?: string;
  buildingId?: number; // Not For Saving
  buildingCategoryId?: number; // Not For Saving
  roomId?: number; // roomId Is Same As buildingSubCategoryId
}
export interface EditSchoolPeriod {
  schoolPeriodAllocationId: number;
  sectionSubjectId?: number;
  teacherId?: string;
  roomId?: number;
}
